"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/keys"));
var render = function render() {
  var _context;
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-inputtools-style",
    on: {
      "mousedown": function mousedown($event) {
        $event.preventDefault();
      },
      "click": function click($event) {
        $event.preventDefault();
      },
      "touchstart": function touchstart($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "kiwi-inputtools-style-sample",
    style: _vm.sampleStyle
  }, [_vm._v(" " + _vm._s(_vm.$t('input_style_sample')) + " ")]), _c('div', {
    staticClass: "kiwi-inputtools-style-top"
  }, [_c('div', {
    staticClass: "kiwi-inputtools-style-grid kiwi-inputtools-style-base"
  }, _vm._l((0, _keys.default)(_context = Array(16)).call(_context), function (colourCode) {
    return _c('div', {
      key: 'colour' + colourCode,
      staticClass: "kiwi-inputtools-style-button",
      class: 'irc-bg-colour-' + colourCode,
      attrs: {
        "data-code": colourCode
      },
      on: {
        "click": _vm.onColourClick,
        "touchend": _vm.onColourClick
      }
    }, [_vm._v(" ")]);
  }), 0), _c('div', {
    staticClass: "kiwi-inputtools-style-grid kiwi-inputtools-style-modifiers"
  }, [_c('div', {
    staticClass: "kiwi-inputtools-style-button",
    class: {
      'kiwi-inputtools-style--disabled': _vm.bgColourDisabled
    },
    attrs: {
      "title": _vm.toggleColourTitle
    },
    on: {
      "click": _vm.toggleColour,
      "touchend": _vm.toggleColour
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_vm.fgColour ? _c('path', {
    attrs: {
      "d": "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zm64 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z"
    }
  }) : _c('path', {
    attrs: {
      "d": "M448 256c0-106-86-192-192-192V448c106 0 192-86 192-192zm64 0c0 141.4-114.6 256-256 256S0 397.4 0 256S114.6 0 256 0S512 114.6 512 256z",
      "transform": "rotate(180, 256, 256)"
    }
  })])]), _c('div', {
    staticClass: "kiwi-inputtools-style-button",
    attrs: {
      "title": _vm.$t('input_style_bold')
    },
    on: {
      "click": function click($event) {
        return _vm.toggleStyle('bold');
      },
      "touchend": function touchend($event) {
        return _vm.toggleStyle('bold');
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 384 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"
    }
  })])]), _c('div', {
    staticClass: "kiwi-inputtools-style-button",
    attrs: {
      "title": _vm.$t('input_style_italic')
    },
    on: {
      "click": function click($event) {
        return _vm.toggleStyle('italic');
      },
      "touchend": function touchend($event) {
        return _vm.toggleStyle('italic');
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 384 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"
    }
  })])]), _c('div', {
    staticClass: "kiwi-inputtools-style-button",
    attrs: {
      "title": _vm.$t('input_style_underline')
    },
    on: {
      "click": function click($event) {
        return _vm.toggleStyle('underline');
      },
      "touchend": function touchend($event) {
        return _vm.toggleStyle('underline');
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
    }
  })])]), _c('div', {
    staticClass: "kiwi-inputtools-style-button",
    attrs: {
      "title": _vm.$t('input_style_strikethrough')
    },
    on: {
      "click": function click($event) {
        return _vm.toggleStyle('strikethrough');
      },
      "touchend": function touchend($event) {
        return _vm.toggleStyle('strikethrough');
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"
    }
  })])]), _c('div', {
    staticClass: "kiwi-inputtools-style-button",
    attrs: {
      "title": _vm.$t('input_style_clear')
    },
    on: {
      "click": function click($event) {
        return _vm.ircinput.clearStyles();
      },
      "touchend": function touchend($event) {
        return _vm.ircinput.clearStyles();
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M258.7 57.4L25.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7H256h9.4H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H355.9L486.6 285.3c25-25 25-65.5 0-90.5L349.3 57.4c-25-25-65.5-25-90.5 0zM265.4 416H256l-105.4 0-80-80L195.3 211.3 332.7 348.7 265.4 416z"
    }
  })])]), _c('div', {
    staticClass: "kiwi-inputtools-style-button kiwi-inputtools-style-reset",
    attrs: {
      "title": _vm.$t('input_style_remove')
    },
    on: {
      "click": function click($event) {
        return _vm.ircinput.resetStyles();
      },
      "touchend": function touchend($event) {
        return _vm.ircinput.resetStyles();
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "d": "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
    }
  })])]), _c('div', {
    staticClass: "kiwi-inputtools-style-button kiwi-inputtools-style-expand",
    attrs: {
      "title": _vm.$t(_vm.extColours ? 'input_style_hide' : 'input_style_show')
    },
    on: {
      "click": function click($event) {
        return _vm.toggleExtended();
      },
      "touchend": function touchend($event) {
        return _vm.toggleExtended();
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512"
    }
  }, [_vm.extColours ? _c('path', {
    attrs: {
      "d": "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L269.3 256 406.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
    }
  }) : _c('path', {
    attrs: {
      "d": "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L370.7 256 233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L178.7 256 41.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    }
  })])])])]), _c('transition-expand', [_vm.extColours ? _c('div', {
    staticClass: "kiwi-inputtools-style-grid kiwi-inputtools-style-palette"
  }, _vm._l(_vm.extendedColourRange, function (colourCode) {
    return _c('div', {
      key: 'colour' + colourCode,
      staticClass: "kiwi-inputtools-style-button",
      class: 'irc-bg-colour-' + colourCode,
      attrs: {
        "data-code": colourCode
      },
      on: {
        "click": _vm.onColourClick,
        "touchend": _vm.onColourClick
      }
    }, [_vm._v(" ")]);
  }), 0) : _vm._e()])], 1);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;